import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { DashboardProvider, useDashboardContext } from '../../../context/DashboardContext';
import PartnerDashboardHero from '../../../components/Dashboard/PartnerDashboardHero';
import ReservationStatsCards from '../../../components/Dashboard/ReservationStatsCards';
import UpcomingReservations from '../../../components/Dashboard/UpcomingReservations';
import RecentReservationsAndReviews from '../../../components/Dashboard/RecentReservationsAndReviews';

const ShopHomeContentInner = () => {
  const navigate = useNavigate();
  const {
    loading,
    stats,
    upcomingReservations,
    recentReservations,
    recentReviews,
    fetchDashboardData
  } = useDashboardContext();

  useEffect(() => {
    const token = localStorage.getItem('token_partner_shop');
    let businessId = localStorage.getItem('id_partner_shop');

    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        businessId = payload.business_id || payload._id || businessId;
      } catch (e) {
        console.error('Error decoding shop token:', e);
      }
    }

    if (businessId) {
      fetchDashboardData('shop', businessId, token);
    }
  }, [fetchDashboardData]);

  if (loading) {
    return (
      <div className="flex h-[50vh] items-center justify-center">
        <div className="w-10 h-10 border-4 border-[#067978] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6 sm:space-y-8 animate-in fade-in duration-700 pb-10">
      <Toaster position="top-right" />

      {/* Header Overview */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h2 className="text-xl sm:text-3xl font-extrabold text-[#067978] tracking-tight">
            Shop Overview
          </h2>
          <p className="text-slate-500 text-xs sm:text-sm font-medium mt-1">
            Manage your store orders, upcoming guest visits, and customer feedback.
          </p>
        </div>
      </div>

      {/* Section 1: Poster Hero Slider */}
      <PartnerDashboardHero category="shop" />

      {/* Section 2: 2 Stat Cards (Active Reservation & Total Reservations) */}
      <ReservationStatsCards
        activeReservations={stats.activeReservations}
        totalReservations={stats.totalReservations}
      />

      {/* Section 3: Upcoming Reservations */}
      <UpcomingReservations
        upcomingReservations={upcomingReservations}
        navigate={navigate}
        bookingPath="/shop/booking"
      />

      {/* Section 4: 2-Column Grid (Recent Reservations & Recent Reviews) */}
      <RecentReservationsAndReviews
        recentReservations={recentReservations}
        recentReviews={recentReviews}
        navigate={navigate}
        bookingPath="/shop/booking"
        reviewsPath="/shop/reviews"
      />
    </div>
  );
};

const DashboardHome = () => (
  <DashboardProvider>
    <ShopHomeContentInner />
  </DashboardProvider>
);

export default DashboardHome;
